import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Selectables } from 'src/app/business/swodoc/view-models/selectables-view-model';
import { ISelectionItem } from 'src/app/common/contracts/components/selection-item';
import { SelectionItem } from 'src/app/shared/models/selectionItem';

@Component({
  selector: 'swodoc-node-multiplechoice',
  templateUrl: 'swodoc-node-multiplechoice.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwodocNodeMultiplechoice implements OnInit {
  @Input()
  node: any;
  @Output()
  changed: EventEmitter<any> = new EventEmitter<any>();
  allowMultiple: boolean;
  private _value: Selectables | Selectables[];

  ngOnInit() {
    this.allowMultiple =
      !this.node.options || this.node.options.allowMultiple === undefined || this.node.options.allowMultiple
        ? true
        : false;
    if (this.node && this.node.selectables && this.node.selectables.length > 0) {
      if (this.allowMultiple) {
        this._value = [];
        this.node.selectables
          .filter(f => f.selected)
          .forEach(m => {
            (this._value as Selectables[]).push(m);
          });
      } else {
        this._value = this.node.selectables.find(f => f.selected);
      }
    } else {
      this._value = this.allowMultiple ? [] : undefined;
    }
  }

  get selectionItems(): ISelectionItem[] {
    if (this.node && this.node.selectables && this.node.selectables.length) {
      const selectionItems: ISelectionItem[] = [];
      for (const item of this.node.selectables) {
        selectionItems.push(new SelectionItem(item, item.label));
      }
      return selectionItems;
    }
    return [];
  }

  get value(): Selectables | Selectables[] {
    return this._value;
  }

  set value(value: Selectables | Selectables[]) {
    this._value = value;
    if (value !== undefined) {
      this.node.selectables.forEach(m => (m.selected = false));
      if (this.allowMultiple && Array.isArray(value)) {
        value.forEach(item => {
          const sel = this.node.selectables.find(f => f === item);
          if (sel) {
            sel.selected = true;
          }
        });
      } else {
        const sel = this.node.selectables.find(f => f === value);
        if (sel) {
          sel.selected = true;
        }
      }
      this.changed.emit(this.node);
    }
  }

  public compareFn(s1: Selectables, s2: Selectables) {
    return s1 && s2 ? s1.value === s2.value && s1.label === s2.label : s1 === s2;
  }
}
